module.exports = __webpack_public_path__ + "img/image-not-available.474a6836.png";